import { render, staticRenderFns } from "./ComponentContainer.vue?vue&type=template&id=584531c2&scoped=true"
import script from "./ComponentContainer.vue?vue&type=script&lang=js"
export * from "./ComponentContainer.vue?vue&type=script&lang=js"
import style0 from "./ComponentContainer.vue?vue&type=style&index=0&id=584531c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584531c2",
  null
  
)

export default component.exports